import http from "../../common/services/httpService";
import {Api, apiUrls, SortingAndFilteringParams} from "../../helpers/api";
import {PageableModel} from "../../common/models/table";
import {AxiosPromise, AxiosResponse} from "axios";
import {NewPackModel, PackingModel} from "../models/packing";
import {HttpErrorModel} from "../../common/models/httpError";

export class PackingService {
    private static basicUrl = apiUrls.dictionaries.packing;

    public static async getAll(sortingAndFilteringParams?: SortingAndFilteringParams, name?: string): Promise<AxiosResponse<PageableModel<PackingModel>>> {
        if (sortingAndFilteringParams) {
            const nameFilter = name && `name~:${name}`;
            sortingAndFilteringParams.filterCondition = `${nameFilter}`;
        }

        const url = Api.addSortingAndFilteringParams(Api.getUrl(this.basicUrl), sortingAndFilteringParams);
        return await http.get<PageableModel<PackingModel>>(url);
    }

    public static async getPacking(id: string): Promise<AxiosResponse<PackingModel>> {
        return await http.get(`${Api.getUrl(this.basicUrl)}/${id}`);
    }

    public static async addPacking(data: NewPackModel): Promise<AxiosPromise> {
        return await http.post(Api.getUrl(this.basicUrl), data);
    }

    public static async removePacking(id: string): Promise<AxiosResponse> {
        return await http.delete(`${Api.getUrl(this.basicUrl)}/${id}`);
    }

    public static async modifyPacking(data: NewPackModel, id: string): Promise<AxiosResponse<HttpErrorModel[]|any>> {
        return await http.post(`${Api.getUrl(this.basicUrl)}/${id}`, data);
    }
}
